import React from "react";
import "./Profile.css";
import my_photo from "./image/dance.jpg";
import bird1 from "./image/IMG_4317.jpg";
import bird2 from "./image/IMG_4459.jpg";
import hakodate from "./image/yakei.jpg";
import unity from "./image/unitynavMesh1.png";
import toilet from "./image/トイレ.png";
import toilet1 from "./image/toire.png";
function profile() {
  return (
    <div class="container">
      <h2 class="profile">profile</h2>
      <section class="wrapper">
        <div class="profile_container">
          <div class="content">
            <div class="content-item">
              <img class="photo1" src={my_photo} alt="dance" />
            </div>
            <div class="content-text">
              <div class="text">
                <h2 class="heading">-FloorJackCrew-</h2>
                <p>大阪工業大学ストリートダンス部FloorJackCrewに所属</p>
                <p>所属ジャンルはHIPHOPとLOCK</p>
                <p>HIPHOPジャンルリーダーと幹部(会計)に任命され</p>
                <p>振付,曲編集,レッスンなども行っていた</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="wrapper">
        <div class="game_container">
          <div class="content">
            <div class="slide">
              <img class="dai" src={unity} alt="unity" />
              <img class="dai" src={toilet} alt="unity" />
              <img class="dai" src={toilet1} alt="unity" />
            </div>
            <div class="content-text">
              <div class="text">
                <div class="ph">
                  <h2 class="heading">-Game Creation-</h2>
                </div>
                <p>一人称視点の田舎の廃校舎を舞台とした</p>
                <p>和製ホラーゲームを制作している</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="wrapper">
        <div class="photo_container">
          <div class="content">
            <div class="slide">
              <img src={bird1} alt="recerch" />
              <img src={bird2} alt="recerch" />
              <img src={hakodate} alt="recerch" />
            </div>
            <div class="content-text">
              <div class="text">
                <div class="ph">
                  <h2 class="heading">-Photograph-</h2>
                </div>
                <p>風景や人物の写真をよく撮る</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="wrapper">
        <div class="note_container">
          <div class="content">
            <div class="content-text">
              <div class="text">
                <div class="ph">
                  <h2 class="heading">-Note-</h2>
                </div>
                <p>環境の整え方や個人的に覚えておきたいことの置き場</p>
              </div>
            </div>
          </div>
          <details>
            <summary>クリックまたはタップして記事一覧を表示</summary>
            <li>
              <a
                href="https://zenn.dev/okaito/articles/5a9e24f4223a6c"
                class="cp_link"
              >
                VScodeでLaTex環境を整える際のあれこれ
              </a>
            </li>
            <li>
              <a
                href="https://zenn.dev/okaito/articles/871882f0478b71"
                class="cp_link"
              >
                ubuntuで最低限必要だと思うセットアップ手順を残す
              </a>
            </li>
          </details>
        </div>
      </section>
    </div>
  );
}

export default profile;
